import UnavailableSeatPill from './UnavailableSeatPill';
export default UnavailableSeatPill;
